/* Maison Fianchetto (21/10, retour cliente : « des photos des carrousels ne s'affichent pas »).
   Les photos en chargement différé (loading="lazy") cachées par le cadre d'un carrousel ne sont téléchargées
   qu'au moment où elles entrent dans le cadre : sur téléphone, on voit un vide pendant le glissement.
   Ce script les fait charger un peu avant :
   - rangées et galeries qui défilent à l'horizontale : les photos jusqu'à deux écrans devant (et un derrière) ;
   - cartes produit à deux photos (survol sur ordinateur, glissement sur téléphone) : la 2e photo des cartes proches de l'écran.
   Seulement pour les carrousels proches de l'écran : le reste de la page garde le chargement différé. */
(function () {
  if (window.mfLazy) return;
  window.mfLazy = true;

  var ROWS = '.product__media-list, .mf-rail__list, .slider, .mf-recent__list ul';

  function eager(img) {
    if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
  }
  function nearScreen(r) {
    var h = window.innerHeight;
    return r.bottom > -h && r.top < h * 2;
  }

  function row(list) {
    var lr = list.getBoundingClientRect();
    if (!nearScreen(lr) || !lr.width) return;
    var w = lr.width;
    var imgs = list.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      var x = imgs[i].getBoundingClientRect().left - lr.left;
      if (x > -w * 1.1 && x < w * 2.1) eager(imgs[i]);
    }
  }

  function scan() {
    var lists = document.querySelectorAll(ROWS);
    for (var i = 0; i < lists.length; i++) {
      var l = lists[i];
      if (!l.mfLazy) {
        l.mfLazy = true;
        l.addEventListener('scroll', function () { soon(); }, { passive: true });
      }
      row(l);
    }
    var second = document.querySelectorAll('.card__media .media--hover-effect > img[loading="lazy"]');
    for (var j = 0; j < second.length; j++) {
      if (nearScreen(second[j].parentNode.getBoundingClientRect())) eager(second[j]);
    }
  }

  // setTimeout plutôt que requestAnimationFrame (rAF ne tourne pas dans un onglet caché)
  var t = 0;
  function soon() {
    if (t) return;
    t = setTimeout(function () {
      t = 0;
      scan();
    }, 150);
  }

  // 21/10 (vitesse) : tout démarre une fois la page chargée. Avant, un passage immédiat (et un à chaque ajout dans la page
  // pendant le chargement) mesurait toutes les photos des carrousels : calculs de mise en page avant le premier affichage,
  // et une quinzaine de photos hors écran téléchargées en même temps que la photo du grand visuel.
  // Le défilement, lui, déclenche le passage tout de suite (cas d'un visiteur qui glisse avant la fin du chargement).
  window.addEventListener('scroll', function () { soon(); }, { passive: true });
  window.addEventListener('resize', function () { soon(); });
  function start() {
    // rangées ajoutées après coup (« Vous aimerez aussi », changement de couleur sur la fiche)
    if ('MutationObserver' in window) {
      new MutationObserver(function () { soon(); }).observe(document.body, { childList: true, subtree: true });
    }
    scan();
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
